import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.planning')
  .service('PlanningProjectsAPI', PlanningProjectsAPI);

function PlanningProjectsAPI(): BringozApi {
  return {
    base: `/planning/projects`,
    infiniteScroll: {
      address: `/planning/projects`,
      cmd: 'GET'
    },
    actions: {
      getAll: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      create: {
        address: '',
        cmd: 'PUT',
        updateable: false
      },
      getOne: {
        address: '{id}',
        cmd: 'GET',
        updateable: true
      },
      update: {
        address: '{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteOne: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false,
        headers: {
          'Content-Type': 'application/json'
        }
      },
      getProjectJobs: {
        address: '{projectId}/jobs',
        cmd: 'GET',
        updateable: true
      },
      getProjectResources: {
        address: '{projectId}/resources',
        cmd: 'GET',
        updateable: true
      },
      getProjectDepots: {
        address: '{projectId}/depots',
        cmd: 'GET',
        updateable: true
      },
      addJobsToProject: {
        address: '{id}/jobs',
        cmd: 'PUT',
        updateable: false
      },
      deleteJobsFromProject: {
        address: '{id}/jobs',
        cmd: 'DELETE',
        updateable: false,
        headers: {
          'Content-Type': 'application/json'
        }
      },
      updateJobInProject: {
        address: '{id}/jobs/{jobId}',
        cmd: 'POST',
        updateable: false
      },
      addResourcesToProject: {
        address: '{id}/resources',
        cmd: 'PUT',
        updateable: false
      },
      addDepotsToProject: {
        address: '{id}/depots',
        cmd: 'PUT',
        updateable: false
      },
      deleteResourcesFromProject: {
        address: '{id}/resources',
        cmd: 'DELETE',
        updateable: false,
        headers: {
          'Content-Type': 'application/json'
        }
      },
      deleteDepotsFromProject: {
        address: '{id}/depots',
        cmd: 'DELETE',
        updateable: false,
        headers: {
          'Content-Type': 'application/json'
        }
      },
      updateProjectDetails: {
        address: '{id}',
        cmd: 'POST',
        updateable: false
      },
      updateProjectSettings: {
        address: '{id}/settings',
        cmd: 'POST',
        updateable: false
      },
      createDraftInProject: {
        address: '{id}/drafts',
        cmd: 'PUT',
        updateable: false
      },
      getDraftInProject: {
        address: '{id}/drafts/{draftId}',
        cmd: 'GET',
        updateable: false
      },
      getDraftsInProject: {
        address: '{id}/drafts',
        cmd: 'GET',
        updateable: false
      },
      selectDraftInProject: {
        address: '{id}/select/{draftId}',
        cmd: 'POST',
        updateable: false
      },
      updateDraftInProject: {
        address: '{id}/drafts/{draftId}',
        cmd: 'POST',
        updateable: false
      },
      updateDraftSettings: {
        address: '{id}/drafts/{draftId}/settings',
        cmd: 'POST',
        updateable: false
      },
      deleteDraftsFromProject: {
        address: '{id}/drafts',
        cmd: 'DELETE',
        updateable: false,
        headers: {
          'Content-Type': 'application/json'
        }
      },
      optimizeDraft: {
        address: '{id}/drafts/{draftId}/actions/optimize',
        cmd: 'POST',
        updateable: false
      },
      abortOptimizeDraft: {
        address: '{id}/drafts/{draftId}/actions/abort',
        cmd: 'POST',
        updateable: false
      },
      approveAndDispatchDraft: {
        address: '{id}/drafts/{draftId}/actions/dispatch',
        cmd: 'POST',
        updateable: false
      },
      createRouteInDraft: {
        address: '{id}/drafts/{draftId}/routes',
        cmd: 'PUT',
        updateable: false
      },
      addStopsToRoute: {
        address: '{id}/drafts/{draftId}/routes/edit',
        cmd: 'POST',
        updateable: false
      },
      recalcRoutesInDraft: {
        address: '{projectId}/drafts/{draftId}/routes/optimize',
        cmd: 'POST',
        updateable: false
      },
      deleteRouteInDraft: {
        address: '{id}/drafts/{draftId}/routes',
        cmd: 'DELETE',
        updateable: false,
        headers: {
          'Content-Type': 'application/json'
        }
      },
      updateRouteLockState: {
        address: '{id}/drafts/{draftId}/routes/lock',
        cmd: 'POST',
        updateable: false
      },
      getDraftDispatchProgress: {
        address: '{id}/drafts/{draftId}/actions/progress',
        cmd: 'GET',
        updateable: false
      },
      getDraftRouteMockData: {
        address: '{id}/drafts/{draftId}/routes/mock',
        cmd: 'POST',
        updateable: false
      },
      importJobs: {
        address: 'jobs/importer/{projectId}/import',
        cmd: 'POST',
        updateable: false
      },
      resolvePlanningAddress: {
        address: '{id}/drafts/{draftId}/address/{addressId}',
        cmd: 'POST',
        updateable: false
      },
      toggleObligateTimeWindow: {
        address: '{projectId}/drafts/{draftId}/jobs/obligateTimeWindow',
        cmd: 'POST'
      },
      lockJobs: {
        address: '{projectId}/drafts/{draftId}/jobs/lock',
        cmd: 'POST'
      },
      unlockJobs: {
        address: '{projectId}/drafts/{draftId}/jobs/unlock',
        cmd: 'POST'
      },
      getDraftAccountsMetrics: {
        address: '{id}/drafts/{draftId}/metrics/accountsData',
        cmd: 'GET',
        updateable: false
      },
      getDraftSolutionMetrics: {
        address: '{id}/drafts/{draftId}/metrics/solution',
        cmd: 'GET',
        updateable: false
      },
      addClusteringAreaToProject: {
        address: '{id}/addArea',
        cmd: 'POST',
        updateable: false
      },
      removeClusteringAreaFromProject: {
        address: '{id}/removeClusteringArea',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}
